import { createFileRoute, useParams } from '@tanstack/react-router';

import { UserDetailScreen } from '@/features/users/components/shared/UserDetailScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/users/$userId')({
  beforeLoad: () => {
    requirePermission('user:read');
  },
  component: WorkspaceUserDetailRoute,
  staticData: { crumb: 'User' },
});

function WorkspaceUserDetailRoute() {
  const { userId } = useParams({
    from: '/_staff/admin/workspace/users/$userId',
  });
  return <UserDetailScreen userId={userId} listPath="/admin/workspace/users" surface="workspace" />;
}
